// src/components/Authentication/AppleAuthButton.jsx
import React, { useContext } from "react";
import { useAppleSignIn } from "../../hooks/useAppleSignIn";
import { AuthContext } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import "./AppleAuthButton.css";
import appleIcon from "../../assets/apple.svg";
import googleIcon from "../../assets/google.svg";

const AppleAuthButton = ({ className = "", onSuccess, onError, affiliateCode = null, newsletter = false }) => {
  const { signIn: appleSignIn } = useAppleSignIn();
  const { setToken } = useContext(AuthContext);
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);

  const handleAppleLogin = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setLoading(true);
    setError(null);

    try {
      const data = await appleSignIn({
        affiliate: affiliateCode,
        user_service: true,
        newsletter: newsletter,
      });

      setToken(data.access_token);
      localStorage.setItem("token", data.access_token);

      if (onSuccess) onSuccess(data);
      navigate("/shop");
    } catch (err) {
      console.error("Apple login error:", err);
      setError(err.message || "Apple login failed");
      if (onError) onError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button type="button" className={`apple-auth-btn`} onClick={handleAppleLogin} disabled={loading} aria-label="">
      <img src={appleIcon} width="22" height="22" alt="Apple Login" aria-label="" />
      {/*{loading ? 'Signing in...' : children}*/}
      {/*{error && <span className="error">{error}</span>}*/}
    </button>
  );
};

export default AppleAuthButton;
